import bfTabsHead from './bf-tabs-head.vue';
bfTabsHead.install = Vue => Vue.component(bfTabsHead.name,bfTabsHead);
export default bfTabsHead;



// WEBPACK FOOTER //
// ./src/packages/tabs/bf-tabs-head/index.js